import { TALL } from '@/constants/heightMappingTableValues';

export const getDefaultState = () => {
  return {
    activeTags: {
    },
    selectedViewId: null,
    selectedRowHeight: TALL,
    views: [],
  };
};
export const state = getDefaultState();
